var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.696,
    height: 24.696,
    viewBox: "0 0 24.696 24.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta",
    transform: "translate(-6.353 -6.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14405",
    "data-name": "Path 14405",
    d: "M30.349,18c-3.354,0-3.774.015-5.092.075a9.062,9.062,0,0,0-3,.574,6.316,6.316,0,0,0-3.613,3.611,9.02,9.02,0,0,0-.574,3C18.015,26.573,18,26.995,18,30.348s.015,3.773.075,5.09a9.075,9.075,0,0,0,.574,3,6.319,6.319,0,0,0,3.611,3.613,9.069,9.069,0,0,0,3,.574c1.317.06,1.738.075,5.091.075s3.773-.015,5.09-.075a9.075,9.075,0,0,0,3-.574,6.327,6.327,0,0,0,3.611-3.612,9.153,9.153,0,0,0,.574-3c.059-1.317.075-1.737.075-5.09s-.015-3.774-.075-5.092a9.148,9.148,0,0,0-.574-3,6.318,6.318,0,0,0-3.612-3.611,9.09,9.09,0,0,0-3-.574C34.119,18.015,33.7,18,30.345,18Zm-1.108,2.225h1.108c3.3,0,3.688.012,4.99.071a6.836,6.836,0,0,1,2.293.425,4.092,4.092,0,0,1,2.343,2.344,6.823,6.823,0,0,1,.425,2.292c.059,1.3.072,1.693.072,4.988s-.013,3.686-.072,4.988a6.829,6.829,0,0,1-.425,2.292,4.095,4.095,0,0,1-2.343,2.342,6.812,6.812,0,0,1-2.293.425c-1.3.059-1.693.072-4.99.072s-3.688-.013-4.99-.072a6.85,6.85,0,0,1-2.293-.426,4.091,4.091,0,0,1-2.344-2.343,6.823,6.823,0,0,1-.425-2.292c-.059-1.3-.071-1.693-.071-4.99s.012-3.686.071-4.988a6.836,6.836,0,0,1,.425-2.293,4.092,4.092,0,0,1,2.344-2.344,6.821,6.821,0,0,1,2.293-.426c1.139-.051,1.581-.067,3.882-.069Zm7.7,2.05a1.482,1.482,0,1,0,1.482,1.481,1.482,1.482,0,0,0-1.482-1.481Zm-6.591,1.731a6.341,6.341,0,1,0,6.34,6.341,6.342,6.342,0,0,0-6.34-6.341Zm0,2.225a4.116,4.116,0,1,1-4.116,4.116A4.116,4.116,0,0,1,30.349,26.232Z",
    transform: "translate(-11.647 -11.648)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.07552cd958320c742c21732efcb35090.svg";
export { ForwardRef as ReactComponent };